import { render, staticRenderFns } from "./OnlineTimeStatisticsPage.vue?vue&type=template&id=0320afe4&scoped=true&"
import script from "./OnlineTimeStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./OnlineTimeStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0320afe4",
  null
  
)

export default component.exports